import React, { Fragment, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Moment from "react-moment";
import { Link } from "react-router-dom";

import { login, logout, clearMsg } from "../../actions/auth";
import {
  getProfileById,
  joinProfileCommunity,
  leaveProfileCommunity,
} from "../../actions/profile";
import {
  getPosts,
  infiniteScrollPosts,
  getPostsByReaction,
  addPost,
  pinPost,
  unpinPost,
  addPostComment,
  addPostReply,
  addReaction,
  deletePost,
  deleteComment,
  deleteReply,
} from "../../actions/post";
import {
  getModerators,
  banUserCommunity,
  banUserCommunityReply,
  banUserCommunityComment,
} from "../../actions/stream";
import { getGifs, getGifsSearch } from "../../actions/gif";
import { setAlert } from "../../actions/alert";

import IMEAltLogo from "../layout/IME/IMEAltLogo";
import GreenLogo from "../layout/Innovators/GreenLogo";
import CommunityBanner from "../layout/IME/CommunityBanner";
import Alert from "../layout/IME/Alert";
import CreatePost from "../layout/IME/CreatePost";

import TwoFARequest from "../layout/Innovators/TwoFARequest";
import ReportUser from "../layout/IME/ReportChatUser";
import CampaignPostItem from "../layout/Campaign/CampaignPostItem";
import PostReply from "../layout/IME/PostReply";
import CommentReply from "../layout/IME/CommentReply";
import BanUserCommunity from "../layout/IME/BanUserCommunity";
import MessageModal from "../layout/IME/MessageModal";
import BanUserCommunityComment from "../layout/IME/BanUserCommunityComment";
import BanUserCommunityReply from "../layout/IME/BanUserCommunityReply";

const RedSpinner =
  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Red_Spinner.gif";
const GreenSpinner =
  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Green_Spinner.gif";
const BlueSpinner =
  "https://ime.sfo3.cdn.digitaloceanspaces.com/img/Blue_Spinner.gif";

const CampaignCommunity = ({
  auth: {
    user,
    msg,
    channelid,
    firstname,
    lastname,
    jobtitle,
    location,
    verified,
  },
  profile: { profile, profileloading, members },
  post: { posts, posts_loading, reactions, comments, replies, errorMessage },
  getGifs,
  getGifsSearch,
  gif: { gifs, loading },
  stream: { moderators },
  report,
  getProfileById,
  joinProfileCommunity,
  leaveProfileCommunity,
  login,
  logout,
  getModerators,
  getPosts,
  infiniteScrollPosts,
  getPostsByReaction,
  isAuthenticated,
  addPost,
  pinPost,
  unpinPost,
  addPostComment,
  addPostReply,
  addReaction,
  deletePost,
  deleteComment,
  deleteReply,
  banUserCommunity,
  banUserCommunityComment,
  banUserCommunityReply,
  clearMsg,
}) => {
  const Element = useRef(null);
  const [showReportUser, setShowReportUser] = useState({
    submit: false,
    confirm: false,
  });
  const [showAuthentication, setShowAuthentication] = useState(true);
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [showMenu, setShowMenu] = useState(false);
  const [createPost, setcreatePostOpen] = useState(false);
  const [Comment, setPostComment] = useState({ text: "", gif: "" });
  const [Reply, setPostReply] = useState({ text: "", gif: "" });
  const [postReply, setShowPostReply] = useState(false);
  const [replyComment, setReplyComment] = useState(false);
  const [reactionTargetDelight, setReactionTargetDelight] = useState({
    channelid: "roland",
    type: "delight",
  });
  const [reactionTargetHilarious, setReactionTargetHilarious] = useState({
    channelid: "roland",
    type: "hilarious",
  });
  const [reactionTargetDreamy, setReactionTargetDreamy] = useState({
    channelid: "roland",
    type: "dreamy",
  });
  const [reactionTargetYikes, setReactionTargetYikes] = useState({
    channelid: "roland",
    type: "yikes",
  });
  const [reactionTargetEyeRoll, setReactionTargetEyeRoll] = useState({
    channelid: "roland",
    type: "eyeRoll",
  });
  const [reactionTargetAngry, setReactionTargetAngry] = useState({
    channelid: "roland",
    type: "angry",
  });
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showBanUser, setShowBanUser] = useState({
    submit: false,
    confirm: false,
  });
  const [showBanUserComment, setShowBanUserComment] = useState({
    submit: false,
    confirm: false,
  });
  const [showBanUserReply, setShowBanUserReply] = useState({
    submit: false,
    confirm: false,
  });
  const [bannedUser, setBannedUser] = useState({
    post_id: "",
    comment_id: "",
    reply_id: "",
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    text: "",
    image: "",
    video: "",
    gif: "",
  });
  const [reportedUser, setReportedUser] = useState({
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    text: "",
    image: "",
    video: "",
    gif: "",
  });
  const [commentReply, setCommentReply] = useState({
    id: "",
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    text: "",
    image: "",
    video: "",
    gif: "",
  });
  const [replyToComment, setReplyToComment] = useState({
    id: "",
    commentId: "",
    role: "",
    channelid: "",
    avatar: "",
    firstname: "",
    lastname: "",
    jobtitle: "",
    text: "",
    gif: "",
  });

  let postCount = 10;

  const handleScroll = () => {
    if (
      Element.current.clientHeight + Element.current.scrollTop >=
      Element.current.scrollHeight
    ) {
      infiniteScrollPosts("roland", postCount);

      postCount += 10;
    }
  };

  function AddReaction(id, channelid, type) {
    addReaction(id, channelid, type);
  }

  const AddReply = (id, _id, profile_channelid, replyText, replyGif) => {
    addPostReply(id, _id, profile_channelid, replyText, replyGif);
  };

  const DeleteReply = (id, commentId, _id, profile_channelid) => {
    deleteReply(id, commentId, _id, profile_channelid);
  };

  useEffect(() => {
    getProfileById("roland");
    getModerators("roland");
  }, [getModerators, getPosts, getProfileById, isAuthenticated, verified]);

  useEffect(() => {
    getPosts("roland");
  }, [getPosts]);

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    login(email, password);
  };

  let MEMBER;

  if (members && members.length > 0) {
    MEMBER = members.find((x) => x.channelid === user.channelid);
  }

  useEffect(() => {
    Element.current.addEventListener("scroll", handleScroll);

    return () => Element.current.addEventListener("scroll", handleScroll);
  }, []);

  return (
    <Fragment>
      {verified && !isAuthenticated && (
        <TwoFARequest
          setShowAuthentication={setShowAuthentication}
          channelid={channelid}
          firstname={firstname}
          lastname={lastname}
          jobtitle={jobtitle}
          location={location}
        />
      )}
      {showBanUser.submit && (
        <BanUserCommunity
          bannedUser={bannedUser}
          banUserCommunity={banUserCommunity}
          setShowBanUser={setShowBanUser}
          profile_id={profile.channelid}
        />
      )}
      {showBanUserComment.submit && (
        <BanUserCommunityComment
          bannedUser={bannedUser}
          banUserCommunityComment={banUserCommunityComment}
          setShowBanUserComment={setShowBanUserComment}
          profile_id={profile.channelid}
        />
      )}
      {showBanUserReply.submit && (
        <BanUserCommunityReply
          bannedUser={bannedUser}
          banUserCommunityReply={banUserCommunityReply}
          setShowBanUserReply={setShowBanUserReply}
          profile_id={profile.channelid}
        />
      )}
      {createPost && (
        <CreatePost
          user={user}
          profile={profile}
          addPost={addPost}
          setcreatePostOpen={setcreatePostOpen}
          channelid={profile.channelid}
          getGifs={getGifs}
          getGifsSearch={getGifsSearch}
          gifs={gifs}
        />
      )}
      {postReply && (
        <PostReply
          user={user}
          profile={profile}
          setShowPostReply={setShowPostReply}
          Comment={Comment}
          setPostComment={setPostComment}
          channelid={profile.channelid}
          getGifs={getGifs}
          getGifsSearch={getGifsSearch}
          gifs={gifs}
          commentReply={commentReply}
          addPostComment={addPostComment}
        />
      )}
      {replyComment && (
        <CommentReply
          user={user}
          profile={profile}
          addPostReply={addPostReply}
          setReplyComment={setReplyComment}
          Reply={Reply}
          setPostReply={setPostReply}
          channelid={profile.channelid}
          getGifs={getGifs}
          getGifsSearch={getGifsSearch}
          gifs={gifs}
          replyToComment={replyToComment}
        />
      )}
      {showReportUser.submit && (
        <ReportUser
          reportedUser={reportedUser}
          setShowReportUser={setShowReportUser}
          profile_id={profile.channelid}
        />
      )}
      {msg && msg !== "" && (
        <MessageModal msg={msg} user={user} clearMsg={clearMsg} />
      )}
      {report.msg && report.msg !== "" && (
        <MessageModal msg={report.msg} user={user} clearMsg={clearMsg} />
      )}
      {errorMessage !== "" && (
        <MessageModal msg={errorMessage} user={user} clearMsg={clearMsg} />
      )}
      <section className="full-content">
        <nav className="login-nav background-dark-black border-bottom grey">
          {!isAuthenticated && (
            <form
              className="main"
              method="POST"
              onSubmit={(e) => {
                onSubmit(e);
                setprofileDropDown(false);
              }}
            >
              <div className="action-items-index hidden-container-large">
                <div
                  className="action-button-index green"
                  onClick={() => {
                    if (!showMenu && !profileDropDown) {
                      setShowMenu(true);
                    } else if (profileDropDown) {
                      setprofileDropDown(false);
                      setShowMenu(false);
                    } else {
                      setprofileDropDown(false);
                      setShowMenu(false);
                    }
                  }}
                >
                  <i className="fa-solid fa-bars action-icon-index fa-lg green"></i>
                </div>
              </div>
              <div className="action-items-index hidden-container">
                <div
                  className="action-button-index green"
                  onClick={() => {
                    if (!profileDropDown) {
                      setprofileDropDown(true);
                    } else {
                      setprofileDropDown(false);
                    }
                  }}
                >
                  <i className="fas fa-user action-icon-index fa-lg green"></i>
                </div>
                <p className="action-text-index green">Login</p>
              </div>
              <Link to="/">
                <div className="action-items-index green hidden-container">
                  <div className="action-button-index green">
                    <i className="fa-solid fa-house-chimney action-icon-index-alt fa-lg green"></i>
                  </div>
                  <p className="action-text-index green">Home</p>
                </div>
              </Link>
              {profileDropDown && (
                <div className="profile-drop-down-alternate">
                  <div className="profile-drop-container-nav">
                    <div className="label-input">
                      <label htmlFor="email" className="labels green">
                        *Email:
                      </label>
                      {email === "" && <Alert />}
                      <input
                        name="email"
                        className="input-style-nav"
                        type="email"
                        value={email}
                        placeholder="Enter Email Address"
                        onChange={(e) => onChange(e)}
                        tabIndex="2"
                      />
                    </div>
                    <div className="label-input">
                      <label htmlFor="password" className="labels green">
                        *Password:
                      </label>
                      {password === "" && <Alert />}
                      <input
                        name="password"
                        className="input-style-nav"
                        type="password"
                        min={7}
                        maxLength={20}
                        value={password}
                        placeholder="Enter Password"
                        onChange={(e) => onChange(e)}
                        tabIndex="2"
                      />
                      {email !== "" && password !== "" && (
                        <div className="login-button-container-alt">
                          <button
                            className="login-button-alt background-green"
                            type="submit"
                          >
                            Login
                          </button>
                        </div>
                      )}
                      <Link to="/forgotpassword">
                        <p className="forgot green" tabIndex="4">
                          Forgot Password?
                        </p>
                      </Link>
                    </div>
                  </div>
                </div>
              )}
            </form>
          )}
          {isAuthenticated && (
            <div className="user-container">
              <div className="user-avi-container">
                <img
                  src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                    user && user.avatar
                  }`}
                  className="user-avi"
                />
              </div>
              <div className="user-name-info-container">
                <p className="user-name-info"> Hi, {user && user.firstname}!</p>
                <div className="arrows-up-down">
                  {!profileDropDown && (
                    <i
                      className={`fas fa-angle-up mx-5 ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : "blue"
                      }`}
                      onClick={() => setprofileDropDown(true)}
                    ></i>
                  )}
                  {profileDropDown && (
                    <i
                      className={`fas fa-angle-down mx-5 ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : "blue"
                      }`}
                      onClick={() => setprofileDropDown(false)}
                    ></i>
                  )}
                </div>
              </div>
              {profileDropDown && (
                <div className="campaign-profile-drop-down">
                  {user.channelid === "roland" && (
                    <Link to="/liveonime/roland/live">
                      <div className="profile-drop-container">
                        <i
                          className={`fa-solid fa-tower-broadcast fa-lg drop-down-icon ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : "blue"
                          }`}
                        ></i>
                        <p className="drop-down-text">Stream Manager</p>
                      </div>
                    </Link>
                  )}
                  {user.channelid === "roland" && (
                    <Link to="/roland/dashboard">
                      <div className="profile-drop-container">
                        <i
                          className={`fa-solid fa-chart-simple fa-lg drop-down-icon ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : "blue"
                          }`}
                        ></i>
                        <p className="drop-down-text">Dashboard</p>
                      </div>
                    </Link>
                  )}
                  <Link to="/">
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-house-chimney fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Home</p>
                    </div>
                  </Link>
                  {isAuthenticated && !user.banned && (
                    <Link to={`/${user.channelid}/edit`}>
                      <div className="profile-drop-container">
                        <i
                          className={`fa-regular fa-circle-user fa-lg drop-down-icon ${
                            user && user.role === "innovator"
                              ? "green"
                              : user && user.role === "mentor"
                              ? "red"
                              : "blue"
                          }`}
                        ></i>
                        <p className="drop-down-text">Edit Profile</p>
                      </div>
                    </Link>
                  )}
                  <Link to={`/${user && user.channelid}/purchases`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fas fa-dollar-sign fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Purchases</p>
                    </div>
                  </Link>
                  <Link to={`/calendar`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-calendar-days fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      ></i>
                      <p className="drop-down-text">Calendar</p>
                    </div>
                  </Link>
                  <Link to={`/${user.channelid}/settings`}>
                    <div className="profile-drop-container">
                      <i
                        className={`fas fa-cog fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : user && user.role === "employer"
                            ? "blue"
                            : ""
                        }`}
                      ></i>
                      <p className="drop-down-text">Settings</p>
                    </div>
                  </Link>
                  <Link to="/agreement">
                    <div className="profile-drop-container">
                      <i
                        className={`fa-solid fa-file-contract fa-lg drop-down-icon ${
                          user && user.role === "innovator"
                            ? "green"
                            : user && user.role === "mentor"
                            ? "red"
                            : "blue"
                        }`}
                      ></i>
                      <p className="drop-down-text">Terms of Agreement</p>
                    </div>
                  </Link>
                  <div
                    className="profile-drop-container"
                    onClick={() => {
                      logout();
                      setprofileDropDown(false);
                    }}
                    href="#!"
                  >
                    <i
                      className={`fas fa-door-closed fa-lg drop-down-icon ${
                        user && user.role === "innovator"
                          ? "green"
                          : user && user.role === "mentor"
                          ? "red"
                          : user && user.role === "employer"
                          ? "blue"
                          : ""
                      }`}
                    ></i>
                    <p className="drop-down-text">Logout</p>
                  </div>
                </div>
              )}
            </div>
          )}
          {showMenu && !isAuthenticated && (
            <div className="campaign-profile-drop-down-alt">
              <div
                onClick={() => {
                  if (!profileDropDown) {
                    setShowMenu(false);
                    setprofileDropDown(true);
                  } else {
                    setprofileDropDown(false);
                  }
                }}
                className="profile-drop-container"
              >
                <i
                  className={`fa-solid fa-user fa-lg drop-down-icon green`}
                ></i>
                <p className="drop-down-text">Login</p>
              </div>
              <Link to={`/`}>
                <div className="profile-drop-container">
                  <i
                    className={`fa-solid fa-house fa-lg drop-down-icon green`}
                  ></i>
                  <p className="drop-down-text">Home</p>
                </div>
              </Link>
              <Link to={`/calendar`}>
                <div className="profile-drop-container">
                  <i
                    className={`fa-solid fa-calendar-days fa-lg drop-down-icon green`}
                  ></i>
                  <p className="drop-down-text">Calendar</p>
                </div>
              </Link>
              <Link to="/agreement">
                <div className="profile-drop-container">
                  <i
                    className={`fa-solid fa-file-contract fa-lg drop-down-icon green`}
                  ></i>
                  <p className="drop-down-text">Terms of Agreement</p>
                </div>
              </Link>
            </div>
          )}
          <Link to="/">
            <div className="center-nav">
              <div className="index-logo-alt">
                <GreenLogo />
              </div>
              <i className="fas fa-trademark green fa-sm mt-10"></i>
              <div className="index-logo">
                <IMEAltLogo />
              </div>
            </div>
          </Link>
          <div className="buttons hidden-container">
            <Link to="/employers">
              <div className="action-items-index green">
                <div className="action-button-index green">
                  <i className="fas fa-user action-icon-index fa-lg green"></i>
                </div>
                <p className="action-text-index green">Employers</p>
              </div>
            </Link>
            <Link to="/mentors">
              <div className="action-items-index green">
                <div className="action-button-index green">
                  <i className="fas fa-user action-icon-index fa-lg green"></i>
                </div>
                <p className="action-text-index green">Mentors</p>
              </div>
            </Link>
          </div>
        </nav>
      </section>
      <div className="flex-all-content-fixed" ref={Element}>
        <div className="post-container">
          {profileloading ? (
            <div className="profile-error">
              <img src={RedSpinner} alt="profile-spinner" />
            </div>
          ) : (
            <div>
              <CommunityBanner />
              <div className="padding-posts grey">
                <div className="posts-flex-only-container">
                  <div className="mid-container-absolute-alt">
                    <div>
                      <div className="flex-only-container-user">
                        <div
                          className={`avi-color-border-lg ${
                            profile && profile.role === "innovator"
                              ? "green"
                              : profile && profile.role === "mentor"
                              ? "red"
                              : profile && profile.role === "employer"
                              ? "blue"
                              : ""
                          }`}
                        >
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                              profile && profile.avatar
                            }`}
                            alt="community-avatar"
                            className="community-avi"
                          />
                        </div>
                        <div className="community-item-container">
                          <ul className="post-user-items">
                            <li
                              className={`item-font-alt ${
                                profile && profile.role === "innovator"
                                  ? "green"
                                  : profile && profile.role === "mentor"
                                  ? "red"
                                  : profile && profile.role === "employer"
                                  ? "blue"
                                  : ""
                              } bold`}
                            >
                              {profile && profile.channelid}
                            </li>
                            <li className="community-item-alt  bold">
                              {profile && profile.firstname}{" "}
                              {profile && profile.channelid !== "roland"
                                ? profile.lastname
                                : ""}
                            </li>
                            <li className="community-item-alt">
                              {profile && profile.jobtitle}
                            </li>
                            <li className="community-item-alt">
                              {profile.location && profile.location.state},{" "}
                              {profile.location && profile.location.country}
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="community-posts-buttons-container">
                    <div>
                      <div className="flex-only-container-buttons">
                        <div className="post-buttons">
                          {isAuthenticated &&
                            !user.banned &&
                            profile &&
                            members.length > 0 &&
                            members.map((member) => {
                              if (member.channelid === user.channelid) {
                                return (
                                  <button
                                    onClick={() =>
                                      leaveProfileCommunity(profile.channelid)
                                    }
                                    className={`join background-dark-black ${
                                      profile && profile.role === "innovator"
                                        ? "green"
                                        : profile && profile.role === "mentor"
                                        ? "red"
                                        : profile && profile.role === "employer"
                                        ? "blue"
                                        : ""
                                    }`}
                                  >
                                    <i
                                      className={`fa-solid fa-champagne-glasses ${
                                        profile && profile.role === "innovator"
                                          ? "green"
                                          : profile && profile.role === "mentor"
                                          ? "red"
                                          : "blue"
                                      } mr-5`}
                                    ></i>
                                    Member
                                  </button>
                                );
                              }
                            })}
                          {isAuthenticated && user.banned && (
                            <button
                              className={`join background-dark-black ${
                                profile && profile.role === "innovator"
                                  ? "green"
                                  : profile && profile.role === "mentor"
                                  ? "red"
                                  : profile && profile.role === "employer"
                                  ? "blue"
                                  : ""
                              }`}
                            >
                              <i
                                className={`fa-solid fa-ban ${
                                  profile && profile.role === "innovator"
                                    ? "green"
                                    : profile && profile.role === "mentor"
                                    ? "red"
                                    : "blue"
                                } mr-5`}
                              ></i>
                              Banned
                            </button>
                          )}
                          {isAuthenticated &&
                            !user.banned &&
                            MEMBER === undefined &&
                            members &&
                            members.length > 0 &&
                            user.channelid !== profile.channelid && (
                              <button
                                onClick={() =>
                                  joinProfileCommunity(profile.channelid)
                                }
                                className={`join ${
                                  profile && profile.role === "innovator"
                                    ? "background-green"
                                    : profile && profile.role === "mentor"
                                    ? "background-red"
                                    : profile && profile.role === "employer"
                                    ? "background-blue"
                                    : ""
                                }`}
                              >
                                <i className="fa-solid fa-plus black mr-5"></i>
                                Join
                              </button>
                            )}
                          {isAuthenticated &&
                            !user.banned &&
                            members &&
                            members.length <= 0 &&
                            user.channelid !== profile.channelid && (
                              <button
                                onClick={() =>
                                  joinProfileCommunity(profile.channelid)
                                }
                                className={`join ${
                                  profile && profile.role === "innovator"
                                    ? "background-green"
                                    : profile && profile.role === "mentor"
                                    ? "background-red"
                                    : profile && profile.role === "employer"
                                    ? "background-blue"
                                    : ""
                                }`}
                              >
                                <i className="fa-solid fa-plus black mr-5"></i>
                                Join
                              </button>
                            )}
                          {isAuthenticated &&
                            !user.banned &&
                            profile &&
                            members.length > 0 &&
                            members.map((member) => {
                              if (member.channelid === user.channelid) {
                                return (
                                  <button
                                    onClick={() => {
                                      if (!createPost && isAuthenticated) {
                                        setcreatePostOpen(true);
                                      } else {
                                        setcreatePostOpen(false);
                                      }
                                    }}
                                    className={`join ${
                                      profile && profile.role === "innovator"
                                        ? "background-green"
                                        : profile && profile.role === "mentor"
                                        ? "background-red"
                                        : profile && profile.role === "employer"
                                        ? "background-blue"
                                        : ""
                                    }`}
                                  >
                                    <i className="fa-solid fa-feather-pointed black mr-5"></i>
                                    Post
                                  </button>
                                );
                              }
                            })}
                          {isAuthenticated &&
                            !user.banned &&
                            profile &&
                            user.channelid === profile.channelid && (
                              <button
                                onClick={() => {
                                  if (!createPost && isAuthenticated) {
                                    setcreatePostOpen(true);
                                  } else {
                                    setcreatePostOpen(false);
                                  }
                                }}
                                className={`join ${
                                  profile && profile.role === "innovator"
                                    ? "background-green"
                                    : profile && profile.role === "mentor"
                                    ? "background-red"
                                    : profile && profile.role === "employer"
                                    ? "background-blue"
                                    : ""
                                }`}
                              >
                                <i className="fa-solid fa-feather-pointed black mr-5"></i>
                                Post
                              </button>
                            )}
                        </div>
                        <div className="community-members hidden-container">
                          <p className="member">
                            <i
                              className={`fa-solid fa-users mr-5 ${
                                profile && profile.role === "innovator"
                                  ? "green"
                                  : profile && profile.role === "mentor"
                                  ? "red"
                                  : profile && profile.role === "employer"
                                  ? "blue"
                                  : ""
                              } `}
                            ></i>
                            {members.length}
                          </p>
                          <p className="member">
                            <i
                              className={`fa-solid fa-calendar mr-5 ${
                                profile && profile.role === "innovator"
                                  ? "green"
                                  : profile && profile.role === "mentor"
                                  ? "red"
                                  : profile && profile.role === "employer"
                                  ? "blue"
                                  : ""
                              } `}
                            ></i>
                            <Moment format="MM/DD/YYYY">
                              {profile && profile.date}
                            </Moment>
                          </p>
                        </div>
                      </div>
                      <div className="community-info">
                        Hey gang! Welcome to the community! Feel free to share
                        success stories, family and friends, pets, something
                        that will surely give the community a good laugh and
                        more! I want to know how you are doing and how your day
                        is going/has been!
                      </div>
                    </div>
                  </div>
                </div>
                <div className="post-sort-container">
                  <select
                    onChange={(e) => {
                      if (e.target.value === "Latest") {
                        getPosts("roland");
                      } else if (e.target.value === "delight") {
                        setReactionTargetDelight({
                          ...reactionTargetDelight,
                        });
                        getPostsByReaction(
                          reactionTargetDelight.channelid,
                          reactionTargetDelight.type
                        );
                      } else if (e.target.value === "hilarious") {
                        setReactionTargetHilarious({
                          ...reactionTargetHilarious,
                        });
                        getPostsByReaction(
                          reactionTargetHilarious.channelid,
                          reactionTargetHilarious.type
                        );
                      } else if (e.target.value === "dreamy") {
                        setReactionTargetDreamy({
                          ...reactionTargetDreamy,
                        });
                        getPostsByReaction(
                          reactionTargetDreamy.channelid,
                          reactionTargetDreamy.type
                        );
                      } else if (e.target.value === "yikes") {
                        setReactionTargetYikes({
                          ...reactionTargetYikes,
                        });
                        getPostsByReaction(
                          reactionTargetYikes.channelid,
                          reactionTargetYikes.type
                        );
                      } else if (e.target.value === "eyeRoll") {
                        setReactionTargetEyeRoll({
                          ...reactionTargetEyeRoll,
                        });
                        getPostsByReaction(
                          reactionTargetEyeRoll.channelid,
                          reactionTargetEyeRoll.type
                        );
                      } else if (e.target.value === "angry") {
                        setReactionTargetAngry({
                          ...reactionTargetAngry,
                        });
                        getPostsByReaction(
                          reactionTargetAngry.channelid,
                          reactionTargetAngry.type
                        );
                      }
                    }}
                    className={`post-sort ${
                      profile && profile.role === "innovator"
                        ? "background-green"
                        : profile && profile.role === "mentor"
                        ? "background-red"
                        : profile && profile.role === "employer"
                        ? "background-blue"
                        : ""
                    } black`}
                    name="post-type-select"
                  >
                    <option
                      className="select-value background-black white"
                      value="Latest"
                    >
                      Latest
                    </option>
                    <option
                      className="select-value background-black white"
                      value={reactionTargetDelight.type}
                    >
                      Delight
                    </option>
                    <option
                      className="select-value background-black white"
                      value={reactionTargetHilarious.type}
                    >
                      Hilarious
                    </option>
                    <option
                      className="select-value background-black white"
                      value={reactionTargetDreamy.type}
                    >
                      Dreamy
                    </option>
                    <option
                      className="select-value background-black white"
                      value={reactionTargetYikes.type}
                    >
                      Yikes
                    </option>
                    <option
                      className="select-value background-black white"
                      value={reactionTargetEyeRoll.type}
                    >
                      Eye Roll
                    </option>
                    <option
                      className="select-value background-black white"
                      value={reactionTargetAngry.type}
                    >
                      Angry
                    </option>
                  </select>
                  {posts_loading ? (
                    <div className="profile-error">
                      <img
                        src={
                          profile.role === "innovator"
                            ? GreenSpinner
                            : profile.role === "mentor"
                            ? RedSpinner
                            : profile.role === "employer"
                            ? BlueSpinner
                            : ""
                        }
                        alt="profile-spinner"
                      />
                    </div>
                  ) : (
                    <div>
                      {posts && posts.length > 0 ? (
                        posts.map((post) => {
                          return (
                            <CampaignPostItem
                              key={post._id}
                              post={post}
                              user={user}
                              isAuthenticated={isAuthenticated}
                              addPostComment={addPostComment}
                              AddReply={AddReply}
                              profile={profile}
                              profile_channelid={profile.channelid}
                              AddReaction={AddReaction}
                              deletePost={deletePost}
                              deleteReply={deleteReply}
                              comments={comments}
                              replies={replies}
                              setShowReportUser={setShowReportUser}
                              setReportedUser={setReportedUser}
                              setBannedUser={setBannedUser}
                              setShowBanUser={setShowBanUser}
                              setShowBanUserComment={setShowBanUserComment}
                              setShowBanUserReply={setShowBanUserReply}
                              pinPost={pinPost}
                              unpinPost={unpinPost}
                              moderators={moderators}
                              reactions={reactions}
                              deleteComment={deleteComment}
                              DeleteReply={DeleteReply}
                              setCommentReply={setCommentReply}
                              setShowPostReply={setShowPostReply}
                              setReplyComment={setReplyComment}
                              setReplyToComment={setReplyToComment}
                              setPostComment={setPostComment}
                              setPostReply={setPostReply}
                              Comment={Comment}
                              Reply={Reply}
                            />
                          );
                        })
                      ) : (
                        <div
                          className={`empty-content-posts ${
                            profile && profile.role === "innovator"
                              ? "green"
                              : profile && profile.role === "mentor"
                              ? "red"
                              : profile && profile.role === "employer "
                              ? "blue"
                              : ""
                          }`}
                        >
                          No Posts
                        </div>
                      )}
                    </div>
                  )}
                  {posts_loading && (
                    <div className="profile-error">
                      <img
                        src={
                          profile.role === "innovator"
                            ? GreenSpinner
                            : profile.role === "mentor"
                            ? RedSpinner
                            : profile.role === "employer"
                            ? BlueSpinner
                            : ""
                        }
                        alt="profile-spinner"
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
};

CampaignCommunity.propTypes = {
  auth: PropTypes.object.isRequired,
  post: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  login: PropTypes.func.isRequired,
  logout: PropTypes.func.isRequired,
  getModerators: PropTypes.func.isRequired,
  getPosts: PropTypes.func.isRequired,
  infiniteScrollPosts: PropTypes.func.isRequired,
  getPostsByReaction: PropTypes.func.isRequired,
  getProfileById: PropTypes.func.isRequired,
  joinProfileCommunity: PropTypes.func.isRequired,
  leaveProfileCommunity: PropTypes.func.isRequired,
  getGifs: PropTypes.func.isRequired,
  getGifsSearch: PropTypes.func.isRequired,
  addPost: PropTypes.func.isRequired,
  pinPost: PropTypes.func.isRequired,
  unpinPost: PropTypes.func.isRequired,
  addPostComment: PropTypes.func.isRequired,
  addPostReply: PropTypes.func.isRequired,
  addReaction: PropTypes.func.isRequired,
  deletePost: PropTypes.func.isRequired,
  deleteComment: PropTypes.func.isRequired,
  deleteReply: PropTypes.func.isRequired,
  banUserCommunity: PropTypes.func.isRequired,
  banUserCommunityComment: PropTypes.func.isRequired,
  banUserCommunityReply: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  post: state.post,
  profile: state.profile,
  stream: state.stream,
  gif: state.gif,
  report: state.report,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  login,
  logout,
  getModerators,
  getPosts,
  infiniteScrollPosts,
  getPostsByReaction,
  addPost,
  pinPost,
  unpinPost,
  addPostComment,
  addPostReply,
  addReaction,
  getProfileById,
  joinProfileCommunity,
  leaveProfileCommunity,
  getGifs,
  getGifsSearch,
  deletePost,
  deleteComment,
  deleteReply,
  banUserCommunity,
  banUserCommunityComment,
  banUserCommunityReply,
  clearMsg,
})(CampaignCommunity);
